import firebase from 'firebase/compat/app'
import moment from 'moment-timezone'
import store from '../store'
import { AuthUser, Conversation } from '../models'
import axios from 'axios'

export enum MessageType {
  TYPE_CALL = 1,
  TYPE_SMS = 2,
  TYPE_EMAIL = 3,
  TYPE_SMS_REVIEW_REQUEST = 4,
  TYPE_WEBCHAT = 5,
  TYPE_SMS_NO_SHOW_REQUEST = 6,
  TYPE_CAMPAIGN_SMS = 7,
  TYPE_CAMPAIGN_CALL = 8,
  TYPE_CAMPAIGN_EMAIL = 9,
  TYPE_CAMPAIGN_VOICEMAIL = 10,
  TYPE_FACEBOOK = 11,
  TYPE_CAMPAIGN_FACEBOOK = 12,
  TYPE_CAMPAIGN_MANUAL_CALL = 13,
  TYPE_CAMPAIGN_MANUAL_SMS = 14,
  TYPE_GMB = 15,
  TYPE_CAMPAIGN_GMB = 16,
  TYPE_REVIEW = 17,
  TYPE_INSTAGRAM = 18,
  TYPE_WHATSAPP = 19,
  TYPE_CUSTOM_SMS = 20,
  TYPE_CUSTOM_EMAIL = 21,
  TYPE_CUSTOM_PROVIDER_SMS = 22,
  TYPE_CUSTOM_PROVIDER_EMAIL = 23,
  TYPE_LIVE_CHAT = 29,
  TYPE_LIVE_CHAT_INFO_MESSAGE = 30,
  TYPE_IVR_CALL = 24,
  TYPE_ACTIVITY_APPOINTMENT = 31,
  TYPE_ACTIVITY_CONTACT = 25,
  TYPE_ACTIVITY_INVOICE = 26,
  TYPE_ACTIVITY_PAYMENT = 27,
  TYPE_ACTIVITY_OPPORTUNITY = 28,
  TYPE_INFO_FACEBOOK_COMMENT = 32,
  TYPE_INFO_INSTAGRAM_COMMENT = 33,
  TYPE_CUSTOM_CALL = 34,
  TYPE_GROUP_SMS = 35,
  TYPE_INTERNAL_CHAT = 36,
  TYPE_INTERNAL_COMMENT = 37,
  TYPE_ACTIVITY_EMPLOYEE_ACTION_LOG = 38,
  TYPE_NO_SHOW = 100,
}

export enum CallSubType {
  EXTERNAL_CALL = 1,
  VOICE_AI = 2,
  INFO = 3,
}

export enum MessageTypeString {
  TYPE_CALL = 'TYPE_CALL',
  TYPE_SMS = 'TYPE_SMS',
  TYPE_EMAIL = 'TYPE_EMAIL',
  TYPE_SMS_REVIEW_REQUEST = 'TYPE_SMS_REVIEW_REQUEST',
  TYPE_WEBCHAT = 'TYPE_WEBCHAT',
  TYPE_SMS_NO_SHOW_REQUEST = 'TYPE_SMS_NO_SHOW_REQUEST',
  TYPE_CAMPAIGN_SMS = 'TYPE_CAMPAIGN_SMS',
  TYPE_CAMPAIGN_CALL = 'TYPE_CAMPAIGN_CALL',
  TYPE_CAMPAIGN_EMAIL = 'TYPE_CAMPAIGN_EMAIL',
  TYPE_CAMPAIGN_VOICEMAIL = 'TYPE_CAMPAIGN_VOICEMAIL',
  TYPE_FACEBOOK = 'TYPE_FACEBOOK',
  TYPE_CAMPAIGN_FACEBOOK = 'TYPE_CAMPAIGN_FACEBOOK',
  TYPE_CAMPAIGN_MANUAL_CALL = 'TYPE_CAMPAIGN_MANUAL_CALL',
  TYPE_CAMPAIGN_MANUAL_SMS = 'TYPE_CAMPAIGN_MANUAL_SMS',
  TYPE_GMB = 'TYPE_GMB',
  TYPE_CAMPAIGN_GMB = 'TYPE_CAMPAIGN_GMB',
  TYPE_REVIEW = 'TYPE_REVIEW',
  TYPE_INSTAGRAM = 'TYPE_INSTAGRAM',
  TYPE_WHATSAPP = 'TYPE_WHATSAPP',
  TYPE_CUSTOM_SMS = 'TYPE_CUSTOM_SMS',
  TYPE_CUSTOM_EMAIL = 'TYPE_CUSTOM_EMAIL',
  TYPE_CUSTOM_PROVIDER_SMS = 'TYPE_CUSTOM_PROVIDER_SMS',
  TYPE_CUSTOM_PROVIDER_EMAIL = 'TYPE_CUSTOM_PROVIDER_EMAIL',
  TYPE_LIVE_CHAT = 'TYPE_LIVE_CHAT',
  TYPE_LIVE_CHAT_INFO_MESSAGE = 'TYPE_LIVE_CHAT_INFO_MESSAGE',
  TYPE_IVR_CALL = 'TYPE_IVR_CALL',
  TYPE_CUSTOM_CALL = 'TYPE_CUSTOM_CALL',
  TYPE_GROUP_SMS = 'TYPE_GROUP_SMS',
  TYPE_INTERNAL_CHAT = 'TYPE_INTERNAL_CHAT',
  TYPE_INTERNAL_COMMENT = 'TYPE_INTERNAL_COMMENT',
  TYPE_NO_SHOW = 'TYPE_NO_SHOW',
  TYPE_ACTIVITY_APPOINTMENT = 'TYPE_ACTIVITY_APPOINTMENT',
  TYPE_ACTIVITY_CONTACT = 'TYPE_ACTIVITY_CONTACT',
  TYPE_ACTIVITY_INVOICE = 'TYPE_ACTIVITY_INVOICE',
  TYPE_ACTIVITY_PAYMENT = 'TYPE_ACTIVITY_PAYMENT',
  TYPE_ACTIVITY_OPPORTUNITY = 'TYPE_ACTIVITY_OPPORTUNITY',
  TYPE_INFO_FACEBOOK_COMMENT = 'TYPE_INFO_FACEBOOK_COMMENT',
  TYPE_INFO_INSTAGRAM_COMMENT = 'TYPE_INFO_INSTAGRAM_COMMENT',
  TYPE_ACTIVITY_EMPLOYEE_ACTION_LOG = 'TYPE_ACTIVITY_EMPLOYEE_ACTION_LOG',
}

export enum InstagramDMType {
  TYPE_STORY_REPLY = 1,
  TYPE_STORY_MENTION = 2,
}

export enum MessageContentType {
  TEXT = 'text/plain',
  HTML = 'text/html',
}

export enum MessageDirection {
  INBOUND = 'inbound',
  OUTBOUND = 'outbound',
}

export enum LastOutboundMessageAction {
  MANUAL = 'manual',
  AUTOMATED = 'automated',
}

export enum MessageStatus {
  QUEUED = 'queued',
  FAILED = 'failed',
  PENDING = 'pending',
  SENT = 'sent',
  DELIVERED = 'delivered',
  UNDELIVERED = 'undelivered',
  READ = 'read',
  CONNECTED = 'connected',
}

export enum CallStatus {
  PENDING = 'pending',
  COMPLETED = 'completed',
  ANSWERED = 'answered',
  BUSY = 'busy',
  NO_ANSWER = 'no-answer',
  FAILED = 'failed',
  CANCELED = 'canceled',
  VOICEMAIL = 'voicemail',
}
export const SMSMessageTypes = [
  'TYPE_SMS',
  'TYPE_SMS_REVIEW_REQUEST',
  'TYPE_SMS_NO_SHOW_REQUEST',
  'TYPE_CAMPAIGN_SMS',
  'TYPE_CAMPAIGN_MANUAL_SMS',
  'TYPE_CUSTOM_SMS',
  'TYPE_CUSTOM_PROVIDER_SMS',
]

export const CallMessageTypes = ['TYPE_CALL', 'TYPE_CAMPAIGN_CALL', 'TYPE_CAMPAIGN_MANUAL_CALL']
export const EmailMessageTypes = [
  'TYPE_EMAIL',
  'TYPE_CAMPAIGN_EMAIL',
  'TYPE_CUSTOM_EMAIL',
  'TYPE_CUSTOM_PROVIDER_EMAIL',
]
export const FacebookMessageTypes = ['TYPE_FACEBOOK', 'TYPE_CAMPAIGN_FACEBOOK']
export const GMBMessageTypes = ['TYPE_GMB', 'TYPE_CAMPAIGN_GMB']

export interface EmailThread {
  id?: string
  subject?: string
  unread?: boolean
  replied?: boolean
  last_message_timestamp?: Date
  first_message_timestamp?: Date
  message_ids?: string[]
  snippet?: string
  error?: string | any
}

export interface Meta {
  email: EmailThread
  manual_call?: { id: string }
  isv?: {
    code?: number
    error?: boolean
    agencyMsg?: string
    msg?: string
  }
  whatsapp?: {
    parentMessageAltId?: string
    parentMessage?: Message
    attachement?: {
      id: string
      mimeType: string
    }
  }
}

interface CustomTemplateButton {
  type: 'web_url' | 'postback' | 'phone_number' | 'account_link' | 'account_unlink' | 'game_play' | 'booking'
  title?: string
  payload?: string
  url?: string
  game_metadata?: {
    player_id?: string
    context_id?: string
  }
}

// https://developers.facebook.com/docs/messenger-platform/reference/templates/generic#elements
// https://developers.facebook.com/docs/messenger-platform/reference/templates/media#elements

interface CustomTemplateGeneric {
  title?: string
  subtitle?: string
  image_url?: string
  default_action?: {
    type: 'web_url'
    url?: string
  }
  buttons?: CustomTemplateButton[]
  media_type?: 'image' | 'video'
  url?: string
  attachment_id?: string
}

// https://developers.facebook.com/docs/messenger-platform/reference/templates/generic#payload
// https://developers.facebook.com/docs/messenger-platform/reference/templates/button#payload
// https://developers.facebook.com/docs/messenger-platform/reference/templates/media#payload
export interface CustomTemplate {
  template_type: 'button' | 'generic' | 'media'
  text?: string
  buttons?: CustomTemplateButton[]
  elements?: CustomTemplateGeneric[]
  shareable?: boolean
}

export interface QuickReply {
  content_type: string
  title?: string
  payload?: string
  selected?: boolean
  branchId?: string
}

type Status = CallStatus | MessageStatus
export class AttachmentsSyncStatus {
  url: string
  isSynced: boolean
}

export default class Message {
  public static collectionRef(): firebase.firestore.CollectionReference {
    return firebase.firestore().collection('messages')
  }

  public static getById(itemId: string): Promise<Message> {
    return new Promise((resolve, reject) => {
      Message.collectionRef()
        .doc(itemId)
        .get()
        .then((snapshot: firebase.firestore.DocumentSnapshot) => {
          if (snapshot.exists) resolve(new Message(snapshot))
          resolve()
        })
        .catch(err => {
          console.error(err)
          reject(err)
        })
    })
  }

  public static getStreamById(itemId: string): firebase.firestore.DocumentReference {
    return Message.collectionRef().doc(itemId)
  }

  public static getAllMessages(conversationId: string, locationId: string): firebase.firestore.Query {
    const query = this.collectionRef()
      .where('location_id', '==', locationId)
      .where('deleted', '==', false)
      .where('conversation_id', '==', conversationId)
      .orderBy('date_added', 'desc')
    return query
  }

  public static getTypes(messageTypes: any[]) {
    let types: any[] = []
    for (const type of messageTypes) {
      switch (type) {
        case 'TYPE_SMS':
          types = types.concat(SMSMessageTypes.map(val => MessageType[val]))
          break
        case 'TYPE_CALL':
          types = types.concat(CallMessageTypes.map(val => MessageType[val]))
          break
        case 'TYPE_EMAIL':
          types = types.concat(EmailMessageTypes.map(val => MessageType[val]))
          break
        case 'TYPE_FACEBOOK':
          types = types.concat(FacebookMessageTypes.map(val => MessageType[val]))
          break
        case 'TYPE_GMB':
          types = types.concat(GMBMessageTypes.map(val => MessageType[val]))
          break
        case 'TYPE_ACTIVITY_APPOINTMENT':
          types.push(MessageType.TYPE_ACTIVITY_APPOINTMENT)
          break
        case 'TYPE_ACTIVITY_CONTACT':
          types.push(MessageType.TYPE_ACTIVITY_CONTACT)
          break
        case 'TYPE_ACTIVITY_INVOICE':
          types.push(MessageType.TYPE_ACTIVITY_INVOICE)
          break
        case 'TYPE_ACTIVITY_PAYMENT':
          types.push(MessageType.TYPE_ACTIVITY_PAYMENT)
          break
        case 'TYPE_ACTIVITY_OPPORTUNITY':
          types.push(MessageType.TYPE_ACTIVITY_OPPORTUNITY)
          break
        case 'TYPE_ACTIVITY_EMPLOYEE_ACTION_LOG':
          types.push(MessageType.TYPE_ACTIVITY_EMPLOYEE_ACTION_LOG)
          break
        case 'TYPE_LIVE_CHAT':
          types.push(MessageType.TYPE_LIVE_CHAT)
          break
        case 'TYPE_INSTAGRAM':
          types.push(MessageType.TYPE_INSTAGRAM)
          break
        case 'TYPE_REVIEW':
          types.push(MessageType.TYPE_REVIEW)
          break
        case 'TYPE_WHATSAPP':
          types.push(MessageType.TYPE_WHATSAPP)
          break
        default:
          break
      }
    }
    return types
  }

  public static getLastMessage(conversationId: string, locationId: string): firebase.firestore.Query {
    return this.collectionRef()
      .where('deleted', '==', false)
      .where('location_id', '==', locationId)
      .where('conversation_id', '==', conversationId)
      .orderBy('date_added', 'desc')
      .limit(1)
  }

  public static getNewMessages(conversationId: string, locationId: string): firebase.firestore.Query {
    return this.collectionRef()
      .where('deleted', '==', false)
      .where('location_id', '==', locationId)
      .where('conversation_id', '==', conversationId)
      .where('date_added', '>', new Date())
      .orderBy('date_added', 'desc')
      .limit(1)
  }

  public static create(
    locationId: string,
    contactId: string,
    conversationId: string,
    userId: string,
    messageType: number,
    body: string,
    direction: string,
    contentType: string,
    extras?: {
      status?: MessageStatus
      attachments?: string[]
      manualCallId?: string
    }
  ): Message {
    const message = new Message()
    message.locationId = locationId
    message.contactId = contactId
    message.userId = userId
    message.conversationId = conversationId
    message.type = messageType
    message.direction = direction
    message.status = extras && extras.status ? extras.status : MessageStatus.PENDING
    if (body) message.body = body
    if (contentType) message.contentType = contentType
    if (extras && extras.attachments) {
      message.attachments = extras.attachments
    }
    if (extras && extras.manualCallId) {
      message.meta.manual_call = {
        id: extras.manualCallId,
      }
    }
    return message
  }

  public static async send(
    locationId: string,
    contactId: string,
    type: MessageType,
    body?: string,
    contentType?: MessageContentType,
    attachments?: string[],
    manualCallId?: string,
    extras?: {
      assignedTo?: string
      followers?: string[]
    }
  ) {
    let conversationType = Conversation.TYPE_PHONE
    switch (type) {
      case MessageType.TYPE_SMS:
      case MessageType.TYPE_SMS_REVIEW_REQUEST:
      case MessageType.TYPE_CALL:
      case MessageType.TYPE_CAMPAIGN_SMS:
      case MessageType.TYPE_FACEBOOK:
      case MessageType.TYPE_CAMPAIGN_CALL:
      case MessageType.TYPE_LIVE_CHAT:
      case MessageType.TYPE_LIVE_CHAT_INFO_MESSAGE:
        conversationType = Conversation.TYPE_PHONE
    }
    let conversation = await Conversation.getByContactIdAndType(contactId, conversationType, locationId)
    if (!conversation) {
      conversation = await Conversation.createAndSave(locationId, contactId, conversationType, extras)
    }
    return Message.sendWithConversation(conversation, contactId, body, type, contentType, attachments, manualCallId)
  }

  public static async sendWithConversation(
    conversation: Conversation,
    contactId: string,
    body: string,
    messageType: MessageType,
    contentType: MessageContentType,
    attachments?: string[],
    manualCallId?: string
  ) {
    const auth: AuthUser = await store.dispatch('auth/get')
    const conversationUpdate = {}
    if (contentType === MessageContentType.TEXT) {
      conversationUpdate['last_message_body'] = body
    }
    conversationUpdate['last_message_type'] = messageType
    if (
      [
        MessageType.TYPE_SMS,
        MessageType.TYPE_CALL,
        MessageType.TYPE_EMAIL,
        MessageType.TYPE_WEBCHAT,
        MessageType.TYPE_FACEBOOK,
        MessageType.TYPE_LIVE_CHAT,
      ].indexOf(messageType) !== -1
    )
      conversationUpdate['inbox'] = true

    const message = Message.create(
      conversation.locationId,
      contactId,
      conversation.id,
      auth.userId,
      messageType,
      body,
      MessageDirection.OUTBOUND,
      contentType,
      {
        attachments,
        manualCallId,
      }
    )

    const server_timestamp = firebase.firestore.FieldValue.serverTimestamp()
    conversationUpdate['date_updated'] = server_timestamp
    conversationUpdate['last_message_date'] = server_timestamp

    const batch = firebase.firestore().batch()
    batch.update(conversation.ref, conversationUpdate)
    batch.set(message.ref, message.data)
    await batch.commit()
    if ([MessageType.TYPE_CALL].indexOf(messageType) === -1) {
      axios.post('/message/schedule_message', {
        message_id: message.id,
      })
    }

    return message
  }

  private _id: string
  private _data: firebase.firestore.DocumentData
  private _ref: firebase.firestore.DocumentReference
  private _snapshot: firebase.firestore.DocumentSnapshot

  constructor(
    snapshot?: firebase.firestore.DocumentSnapshot | firebase.firestore.QueryDocumentSnapshot | { [key: string]: any }
  ) {
    if (
      snapshot instanceof firebase.firestore.DocumentSnapshot ||
      snapshot instanceof firebase.firestore.QueryDocumentSnapshot
    ) {
      this._id = snapshot.id
      this._data = snapshot.data() || {}
      this._ref = snapshot.ref
      this._snapshot = snapshot
    } else if (snapshot) {
      this._id = snapshot.id
      this._ref = Message.collectionRef().doc(snapshot.id)
      this._data = {}
      for (const key of Object.keys(snapshot)) {
        if (key == 'id' || key == 'scheduledTimestamp') continue
        this[key] = snapshot[key]
      }
      const dateAdded = snapshot.date_added || snapshot.dateAdded,
        dateUpdated = snapshot.date_updated || snapshot.dateUpdated
      if (dateAdded?._seconds) {
        this._data.date_added = new firebase.firestore.Timestamp(dateAdded._seconds, dateAdded._nanoseconds)
      }
      if (dateUpdated?._seconds) {
        this._data.date_updated = new firebase.firestore.Timestamp(dateUpdated._seconds, dateUpdated._nanoseconds)
      }
    } else {
      this._ref = Message.collectionRef().doc()
      this._id = this._ref.id
      this._data = {}
      this.deleted = false
      this.data.date_added = firebase.firestore.FieldValue.serverTimestamp()
      this.data.date_updated = firebase.firestore.FieldValue.serverTimestamp()
    }
  }

  get id(): string {
    return this._id
  }

  get data(): firebase.firestore.DocumentData {
    return this._data
  }

  get ref(): firebase.firestore.DocumentReference {
    return this._ref
  }

  get snapshot() {
    return this._snapshot
  }

  get locationId(): string {
    return this._data.location_id
  }

  set locationId(locationId: string) {
    this._data.location_id = locationId
  }

  get gmbPageId(): string {
    return this._data.gmb_page_id
  }

  set gmbPageId(gmbPageId: string) {
    this._data.gmb_page_id = gmbPageId
  }

  get conversationId(): string {
    return this._data.conversation_id
  }

  set conversationId(conversationId: string) {
    this._data.conversation_id = conversationId
  }

  get conversationProviderId(): string {
    return this._data.conversationProviderId
  }

  set conversationProviderId(conversationProviderId: string) {
    this._data.conversationProviderId = conversationProviderId
  }

  get agentName(): string {
    return this._data.agentName
  }

  set agentName(agentName: string) {
    this._data.agentName = agentName
  }

  get initials(): string {
    if (!this.agentName) return ''
    const parts = this.agentName.split(' ')
    let initials = parts[0].substring(0, 1).toUpperCase()

    if (parts.length > 1) {
      initials += parts[parts.length - 1].substring(0, 1).toUpperCase()
    }
    return initials
  }

  get profileColor() {
    const str = this.agentName
    let hash = 0
    if (str.length == 0) return hash
    for (let i = 0; i < str.length; i++) {
      hash = str.charCodeAt(i) + ((hash << 5) - hash)
      hash = hash & hash // Convert to 32bit integer
    }
    const shortened = Math.abs(hash) % 360
    return 'hsl(' + shortened + ',35%, 60%)'
  }

  get contactId(): string {
    return this._data.contact_id
  }

  set contactId(contactId: string) {
    this._data.contact_id = contactId
  }

  get userId(): string {
    return this._data.user_id
  }

  set userId(userId: string) {
    this._data.user_id = userId
  }

  get dateAdded(): moment.Moment {
    return moment(this._data.date_added.toMillis())
  }

  set dateAdded(dateAdded: moment.Moment | string) {
    if (typeof dateAdded == 'string') {
      this._data.date_added = firebase.firestore.Timestamp.fromMillis(moment(dateAdded).valueOf())
      return
    }
    this._data.date_added = firebase.firestore.Timestamp.fromMillis(dateAdded.valueOf())
  }

  get dateUpdated(): moment.Moment {
    return moment(this._data.date_updated.toMillis())
  }

  set dateUpdated(dateUpdated: moment.Moment | string) {
    if (typeof dateUpdated == 'string') {
      this._data.date_updated = firebase.firestore.Timestamp.fromMillis(moment(dateUpdated).valueOf())
      return
    }
    this._data.date_updated = firebase.firestore.Timestamp.fromMillis(dateUpdated.valueOf())
  }

  get deleted(): boolean {
    return this._data.deleted
  }

  set deleted(deleted: boolean) {
    this._data.deleted = deleted
  }

  get type(): number {
    return this._data.type
  }

  set type(type: number) {
    this._data.type = type
  }

  get altId(): string {
    return this._data.alt_id
  }

  set altId(altId: string) {
    this._data.alt_id = altId
  }

  get body(): string {
    return this._data.body
  }

  set body(body: string) {
    this._data.body = body
  }

  get bodyDownloadUrl(): string {
    return this._data.bodyDownloadUrl
  }

  set bodyDownloadUrl(bodyDownloadUrl: string) {
    this._data.bodyDownloadUrl = bodyDownloadUrl
  }

  get bodyStorageUrl(): string {
    return this._data.bodyStorageUrl
  }

  set bodyStorageUrl(bodyStorageUrl: string) {
    this._data.bodyStorageUrl = bodyStorageUrl
  }

  get direction(): string {
    return this._data.direction
  }

  set direction(direction: string) {
    this._data.direction = direction
  }

  get status(): Status {
    return this._data.status
  }

  set status(status: Status) {
    this._data.status = status
  }

  get thumbVote(): string {
    return this._data.thumb_vote
  }

  set thumbVote(thumbVote: string) {
    this._data.thumb_vote = thumbVote
  }
  get attachments(): string[] {
    return this._data.attachments
  }

  set attachments(attachments: string[]) {
    this._data.attachments = attachments
  }

  get contentType(): string {
    return this._data.content_type
  }

  set contentType(contentType: string) {
    this._data.content_type = contentType
  }

  get reviewerName(): string {
    return this._data.reviewer_name
  }

  set reviewerName(reviewerName: string) {
    this._data.reviewer_name = reviewerName
  }

  get starRating(): number {
    return this._data.star_rating
  }

  set starRating(starRating: number) {
    this._data.star_rating = starRating
  }

  get source(): number {
    return this._data.source
  }

  set source(source: number) {
    this._data.source = source
  }

  get customTemplate(): CustomTemplate {
    return this._data.custom_template
  }

  set customTemplate(customTemplate: CustomTemplate) {
    this._data.custom_template = customTemplate
  }

  get replyTo(): string {
    return this._data.reply_to
  }

  set replyTo(replyTo: string) {
    this._data.reply_to = replyTo
  }

  set replyToMessageId(replyToMessageId: string) {
    this._data.reply_to_message_id = replyToMessageId
  }

  get replyToMessageId(): string {
    return this._data.reply_to_message_id
  }

  get isActivity(): boolean {
    const activityTypes = [
      MessageType.TYPE_ACTIVITY_APPOINTMENT,
      MessageType.TYPE_ACTIVITY_INVOICE,
      MessageType.TYPE_ACTIVITY_OPPORTUNITY,
      MessageType.TYPE_ACTIVITY_CONTACT,
      MessageType.TYPE_ACTIVITY_PAYMENT,
      MessageType.TYPE_ACTIVITY_EMPLOYEE_ACTION_LOG,
    ]

    return activityTypes.includes(this._data.type)
  }

  public save(): Promise<Message> {
    const _self = this
    return new Promise((resolve,reject) => {
      _self.data.date_updated = firebase.firestore.FieldValue.serverTimestamp()
      _self._ref.set(this._data, { merge: true }).then(() => {
        resolve(_self)
      }).catch((error) => {
        reject(error);
      });
    })
  }

  public delete() {
    return Message.collectionRef().doc(this.id).update({
      deleted: true,
    })
  }

  get meta(): Meta {
    if (!this._data.meta) this._data.meta = {}
    if (!this._data.meta.email) this._data.meta.email = {}
    if (!this._data.fb) this._data.fb = {}
    if (!this._data.ig) this._data.ig = {}
    return this._data.meta
  }

  set meta(meta: Meta) {
    this._data.meta = meta
  }

  get instagramDMType(): number {
    return this._data.instagram_dm_type
  }

  set instagramDMType(instagramDMType: number) {
    this._data.instagram_dm_type = instagramDMType
  }

  get scheduledTimestamp(): string | undefined {
    if (!this._data.scheduled_timestamp) return undefined
    return moment(this._data.scheduled_timestamp.toMillis()).tz(moment.tz.guess()).format('ddd, MMM D YYYY, hh:mm A z')
  }
  get attachmentsSyncStatus(): AttachmentsSyncStatus[] {
    return this._data.attachments_sync_status
  }
  set attachmentsSyncStatus(attachmentsSyncStatus: AttachmentsSyncStatus[]) {
    this._data.attachments_sync_status = attachmentsSyncStatus
  }

  get subType(): number {
    return this._data.sub_type
  }

  set subType(subType: number) {
    this._data.sub_type = subType
  }
}
